/* eslint-disable */
import Vue from 'vue'
// import axios from 'axios'
import store from '@/store/index'
import CryptoJS from 'vue-cryptojs'

Vue.use(CryptoJS)

export const toEncrypt = (string, key) => {
  let encryptMethod = 'AES-256-CBC'
  let aesNumber = parseInt(encryptMethod.match(/\d+/)[0])
  let iv = Vue.CryptoJS.lib.WordArray.random(16) // the reason to be 16, please read on `encryptMethod` property.

  let salt = Vue.CryptoJS.lib.WordArray.random(256)
  let iterations = 999
  let encryptMethodLength = aesNumber / 4 // example: AES number is 256 / 4 = 64
  let hashKey = Vue.CryptoJS.PBKDF2(key, salt, {
    hasher: Vue.CryptoJS.algo.SHA512,
    keySize: encryptMethodLength / 8,
    iterations,
  })

  let encrypted = Vue.CryptoJS.AES.encrypt(string, hashKey, {
    mode: Vue.CryptoJS.mode.CBC,
    iv,
  })
  let encryptedString = Vue.CryptoJS.enc.Base64.stringify(encrypted.ciphertext)

  let output = {
    value: encryptedString,
    iv: Vue.CryptoJS.enc.Hex.stringify(iv),
    salt: Vue.CryptoJS.enc.Hex.stringify(salt),
    iterations,
  }

  return Vue.CryptoJS.enc.Base64.stringify(
    Vue.CryptoJS.enc.Utf8.parse(JSON.stringify(output)),
  )
}

export const toDecrypt = (encryptedString, key) => {
  let encryptMethod = 'AES-256-CBC'
  let aesNumber = parseInt(encryptMethod.match(/\d+/)[0])
  let json = JSON.parse(
    Vue.CryptoJS.enc.Utf8.stringify(
      Vue.CryptoJS.enc.Base64.parse(encryptedString),
    ),
  )

  let salt = Vue.CryptoJS.enc.Hex.parse(json.salt)
  let iv = Vue.CryptoJS.enc.Hex.parse(json.iv)

  let encrypted = json.value // no need to base64 decode.

  let iterations = parseInt(json.iterations)
  if (iterations <= 0) {
    iterations = 999
  }
  let encryptMethodLength = aesNumber / 4 // example: AES number is 256 / 4 = 64
  let hashKey = Vue.CryptoJS.PBKDF2(key, salt, {
    hasher: Vue.CryptoJS.algo.SHA512,
    keySize: encryptMethodLength / 8,
    iterations,
  })

  let decrypted = Vue.CryptoJS.AES.decrypt(encrypted, hashKey, {
    mode: Vue.CryptoJS.mode.CBC,
    iv,
  })
  return decrypted.toString(Vue.CryptoJS.enc.Utf8)
}

export const responseApi = payload => {
  const data = payload
  let decr = toDecrypt(data.res, store.state.secretKey)
  return JSON.parse(decr)
}

export const requestApi = payload => {
  let ecr = toEncrypt(payload, store.state.secretKey)
  const data = { req: ecr }
  return data
}

export const requestApiForm = payload => {
  let ecr = toEncrypt(payload, store.state.secretKey)
  let formData = new FormData()
  formData.append('req', ecr)
  // const data = { req: ecr }
  return formData
}
